<div id="green-campus" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Green Campus</h2>

    <hr class="divider">

    <h4 class="section-subtitle">Our Efforts</h4>
    <p><strong>Quality Audits:</strong> We conduct comprehensive quality audits to assess and enhance our sustainability
      practices. These audits help us identify areas for improvement, ensuring that our green initiatives are effective
      and impactful.</p>
    <p><strong>Engaging Activities:</strong> We organize a variety of activities designed to engage the entire college
      community in our Go Green efforts. From tree planting drives and recycling workshops to energy conservation
      campaigns and eco-friendly competitions, these activities foster a sense of collective responsibility towards the
      environment.</p>
    <p><strong>Green Campus Concept:</strong> Our campus is a living laboratory for sustainability. We have implemented
      numerous green infrastructure projects, such as rainwater harvesting systems, solar panels, and energy-efficient
      buildings. These projects not only reduce our environmental footprint but also serve as educational tools for our
      students.</p>

    <h4 class="section-subtitle mt-4">Leadership</h4>
    <p>Ms. Renu Dara, the in-charge of the Go Green team, brings passion and expertise to our sustainability efforts.
      Her leadership and vision are instrumental in driving our initiatives forward, ensuring that we continuously push
      the boundaries of what a green campus can achieve.</p>

    <h4 class="section-subtitle mt-4">Join Us</h4>
    <p>Our 'Go Green' initiative is more than a set of practices; it is a movement that invites every member of our
      college community to participate. By embracing sustainability in our daily lives, we can create a healthier, more
      sustainable future for ourselves and for generations to come.</p>

    <hr class="divider">

    <h4 class="section-subtitle">Go Green Reports</h4>
    <div class="row g-3 mt-2">
      <div class="col-md-4">
        <a href="/assets/pdf/campus-life/GO-GREEN-2023-24.pdf" target="_blank"
          class="pdf-download-btn w-100 text-center">
          <i class="fa fa-file-pdf-o me-2"></i>Go Green 2023-24
        </a>
      </div>
      <div class="col-md-4">
        <a href="/assets/pdf/campus-life/GO-GREEN-2022-23.pdf" target="_blank"
          class="pdf-download-btn w-100 text-center">
          <i class="fa fa-file-pdf-o me-2"></i>Go Green 2022-23
        </a>
      </div>
      <div class="col-md-4">
        <a href="/assets/pdf/campus-life/Go-Green-2021-22.pdf" target="_blank"
          class="pdf-download-btn w-100 text-center">
          <i class="fa fa-file-pdf-o me-2"></i>Go Green 2021-22
        </a>
      </div>
    </div>

  </div>
</div>